/* eslint-disable no-loop-func */
import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import cssClasses from "./ForgetPassword.module.css";

import strip1 from "../../Assets/Images/Login/strip1.svg";
import strip2 from "../../Assets/Images/Login/strip2.svg";
import strip3 from "../../Assets/Images/Login/strip3.svg";
import strip4 from "../../Assets/Images/Login/strip4.svg";
import logo from '../../Assets/Images/SideMenu/vjLogo.jpg';

import { useNavigate } from "react-router-dom";


//subComponent
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";
// import GreenChecked from "../Icons/GreenChecked";
import {   sendResetPasswordMailSales } from "../../Services/LoginService";
import { errorTost, successTost } from "../../Services/Toast";
import { getUserByEmailId } from "../../Services/Users";

const useStyles = makeStyles((theme) => ({
    title: {
      color: "#1C1C1C",
      fontFamily: "Inter-Medium",
      fontSize: "2.4rem",
      lineHeight: "3.2rem",
      marginBottom: "1rem",
    },
    label: {
      display: "inline-block",
      fontFamily: "Inter-Medium",
      fontWeight: "400",
      fontSize: "1.4rem",
      lineheight: "2rem",
      /* identical to box height, or 143% */
  
      /* Gray/500 */
  
      color: "#667085",
      marginRight: "0.4rem",
    },
    signUp: {
      display: "inline-block",
      fontFamily: "Inter-Medium",
      fontWeight: "500",
      fontSize: "1.4rem",
      lineheight: "2rem",
      cursor: "pointer",
      color: "#175CD3",
    },
  }));


export default function ForgetPassword(){
  const navigate = useNavigate();
    const classes = useStyles();
  const [details,setDetails]=useState({
    userEnteredId:'',
  });
  const [helperText,setHelperText]=useState({
    userEnteredId:''
  })
    function getUserDetails(){
      if(details.userEnteredId!==''&&helperText.userEnteredId===''){
        getUserByEmailId(details.userEnteredId).then((userRes)=>{
          console.log(userRes);
          if(userRes.length>0){
            sendResetPasswordMailSales(userRes[0]?.email).then((resetRes)=>{
              console.log("resp: ", resetRes);
              successTost(
                "Reset password link sent successfully to " +
                userRes[0]?.name+
                  "( " +
                  userRes[0]?.email +
                  " )"
              );
               navigate('/login');
            }).catch((err)=>{
              console.log(err);
              errorTost(err.message);
            });
          }else{
            errorTost('This email does not exists');
          }
        }).catch((err)=>{
          console.log(err);
          errorTost(err.message);
        })
        }else{
          if(helperText.userEnteredId===''){
            setHelperText((pre)=>{
              pre.userEnteredId="Please enter email Id";
              return {...pre}
  
            })
          }
        }
    }
    return (
        <div className={cssClasses.wrapperPage}>
          <div className={cssClasses.backgroundImage}>
            <img
              src={strip2}
              className={cssClasses.strip2}
              alt="backgroundImage"
            ></img>
            <img
              src={strip3}
              className={cssClasses.strip3}
              alt="backgroundImage"
            ></img>
            <div className={cssClasses.registerationBlock}>
              <div>
                <img src={logo} style={{ width: "23rem" }} alt="vj-logo"></img>
              </div>
              <div className={classes.title}>Forget Password</div>
              <div style={{ textAlign: "left"}}>
                <CustomInput
                  value={details.userEnteredId}
                  label={"Email"}
                  mandatory={true}
                  handleChange={(newValue) => {
                    console.log(newValue);
                   
                    const emailIDCond = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (!newValue.trim()) {
                      helperText.userEnteredId = "Please Enter Email Id";
                    } else if (!newValue.match(emailIDCond)) {
                      helperText.userEnteredId =
                        "Please Enter Email in Proper Format";
                    } else {
                      helperText.userEnteredId = "";
                    }
                    console.log(newValue);
                    let pre = Object.assign({}, details);
                    pre.userEnteredId = newValue;
                    setDetails({ ...pre });
                  }}
                  placeholder="Enter email id"
                  inputType="label"
                helperText={helperText.userEnteredId}
                
                />
              </div>
          
              <div>
                <Button
                  style={{
                    color: "#ffffff",
                    backgroundColor: "#155EEF",
                  }}
                  btnName={"Send Reset Password Link"}
                 clicked={()=>{getUserDetails()}}
                //   isLoading={}
                  loaderColor={"#fff"}
                />
              </div>
    
              <div>
                <div className={classes.label}>Back to login?</div>
                <div className={classes.signUp} onClick={()=>{
                  navigate('/Login');
                }}>
                  Login
                </div>
              </div>
            
            </div>
            </div>
        </div>
      );
}